export enum MultilegPriceMethod {
  /** Net Price */
  NetPrice = 0,
  /** Reversed Net Price */
  ReversedNetPrice = 1,
  /** Yield Difference */
  YieldDifference = 2,
  /** Individual */
  Individual = 3,
  /** Contract Weighted Average Price */
  ContractWeightedAveragePrice = 4,
  /** Multiplied Price */
  MultipliedPrice = 5,
}
